module.exports = __webpack_public_path__ + "img/161a8f5.jpg";